module.exports = __webpack_public_path__ + "static/2-cfb863e2175ce05b81fd37553b36c4eb.jpg";